/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_SummariesInputs */

const en_svchip_summaries = /** @type {(inputs: Svchip_SummariesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summaries`)
};

const ar_svchip_summaries = /** @type {(inputs: Svchip_SummariesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الملخصات`)
};

const bn_svchip_summaries = /** @type {(inputs: Svchip_SummariesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সামারি`)
};

const de_svchip_summaries = /** @type {(inputs: Svchip_SummariesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenfassungen`)
};

const es_svchip_summaries = /** @type {(inputs: Svchip_SummariesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resúmenes`)
};

const fr_svchip_summaries = /** @type {(inputs: Svchip_SummariesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résumés`)
};

const pt_svchip_summaries = /** @type {(inputs: Svchip_SummariesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumos`)
};

const zh_svchip_summaries = /** @type {(inputs: Svchip_SummariesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摘要`)
};

const tr_svchip_summaries = /** @type {(inputs: Svchip_SummariesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özetler`)
};

const ru_svchip_summaries = /** @type {(inputs: Svchip_SummariesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Резюме`)
};

const pl_svchip_summaries = /** @type {(inputs: Svchip_SummariesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podsumowania`)
};

/**
* | output |
* | --- |
* | "Summaries" |
*
* @param {Svchip_SummariesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_summaries = /** @type {((inputs?: Svchip_SummariesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_SummariesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_summaries(inputs)
	if (locale === "bn") return bn_svchip_summaries(inputs)
	if (locale === "de") return de_svchip_summaries(inputs)
	if (locale === "es") return es_svchip_summaries(inputs)
	if (locale === "fr") return fr_svchip_summaries(inputs)
	if (locale === "pt") return pt_svchip_summaries(inputs)
	if (locale === "zh") return zh_svchip_summaries(inputs)
	if (locale === "tr") return tr_svchip_summaries(inputs)
	if (locale === "ru") return ru_svchip_summaries(inputs)
	if (locale === "pl") return pl_svchip_summaries(inputs)
	return en_svchip_summaries(inputs)
});